// src/pages/shop/ShopReportSettings.jsx
//
// Настройка: какие блоки показывать на странице отчётов.
// Скрытые блоки хранятся локально (набор id). Показываются только блоки,
// доступные магазину (по включённым модулям) — чтобы тут не висело лишнее.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useMyShop } from '../../hooks/useMyShop';
import Icon from '../../components/Icon';
import { BLOCKS, isReportBlockAvailable, HIDDEN_KEY } from './ShopReports';

export default function ShopReportSettings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const shop = useMyShop();

  const available = BLOCKS.filter(b => isReportBlockAvailable(b.id, shop));

  const [hidden, setHidden] = useState(() => {
    try {
      const raw = localStorage.getItem(HIDDEN_KEY);
      if (raw) { const a = JSON.parse(raw); if (Array.isArray(a)) return new Set(a); }
    } catch (e) { /* ignore */ }
    return new Set();
  });

  const persist = (set) => {
    try { localStorage.setItem(HIDDEN_KEY, JSON.stringify([...set])); } catch (e) { /* ignore */ }
  };

  const toggle = (id) => {
    setHidden(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      persist(next);
      return next;
    });
  };

  const showAll = () => { const s = new Set(); persist(s); setHidden(s); };

  return (
    <div className="page" style={{ paddingBottom: 40 }}>
      <div className="page-header">
        <button className="back-btn" onClick={() => navigate('/shop/reports')}><Icon name="chevronLeft" size={18} /></button>
        <div style={{ flex: 1 }}>
          <p className="page-subtitle">{t('reports.pdfReport')}</p>
          <h1 className="page-title">{t('reports.settingsTitle')}</h1>
        </div>
      </div>

      <div style={{ padding: '0 20px' }}>
        <p style={{ fontSize: 13, color: 'var(--fg-muted)', marginBottom: 14, lineHeight: 1.4 }}>
          {t('reports.settingsHint')}
        </p>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
          <button onClick={showAll} style={{ background: 'none', border: 'none', color: 'var(--brand-primary)', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
            {t('reports.showAll')}
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {available.map(b => {
            const shown = !hidden.has(b.id);
            return (
              <label key={b.id} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px',
                background: 'var(--bg-subtle)', borderRadius: 'var(--r-sm)', cursor: 'pointer',
              }}>
                <Icon name={b.iconKey} size={16} color={shown ? 'var(--brand-primary)' : 'var(--fg-faint)'} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontSize: 13, fontWeight: 600, color: shown ? 'var(--fg)' : 'var(--fg-muted)' }}>{t(`reports.block_${b.id}`)}</p>
                  <p style={{ fontSize: 11, color: 'var(--fg-faint)', lineHeight: 1.3 }}>{t(`reports.block_${b.id}_desc`)}</p>
                </div>
                <input type="checkbox" checked={shown} onChange={() => toggle(b.id)} style={{ width: 18, height: 18, flexShrink: 0 }} />
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
}
